import { ArrowUpRight } from 'lucide-react'
import { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import { cn } from '../utils/cn'
import Container from './container'

export default function Metodologia() {
  const [activeItem, setActiveItem] = useState(0)
  const { openModal } = useModal()
  const accordionItems = [
    {
      id: '01',
      title: 'Por quê?',
      description:
        'Para fazer entregas efetivas, tudo começa pelo “porquê”. Com o apoio da metodologia Golden Circle, compreendemos os desafios e as metas de nossos parceiros para criar soluções personalizadas que gerem resultados reais para os negócios.',
    },
    {
      id: '02',
      title: 'Como?',
      description:
        'Avançamos para o "como": somos especialistas em apoiar a evolução de negócios a partir da seleção e do desenvolvimento de soluções que conectam inovação e tecnologia sob medida para a empresa vencer desafios e alcançar metas com eficiência.',
    },
    {
      id: '03',
      title: 'O quê?',
      description:
        'Finalizamos com o "o quê": entregamos soluções inovadoras de alto impacto nas empresas, transformando desafios em oportunidades.',
    },
  ]

  return (
    <section className="bg-[#040116] bg-[url(../assets/cover-proposito.png)] bg-cover bg-no-repeat text-white">
      <Container className="py-28 space-y-9 md:space-y-24">
        <header>
          <h2 className="font-inter-light text-4xl md:text-6xl text-center">
            Metodologia
          </h2>
        </header>
        <main className="flex flex-col md:flex-row items-center justify-between gap-20">
          <div className="relative">
            <img
              src="../assets/img-metodologia.png"
              alt=""
              className="w-full"
            />
            <div className="bg-[#2a0d5db0] backdrop-blur-xs rounded-[30px] py-4 px-4 grid grid-cols-2 items-center w-[calc(100%-14px)] mx-auto absolute bottom-4 left-1/2 translate-x-[-50%]">
              <p className="text-xl font-inter-light">
                Otimize <br /> seu negócio!
              </p>
              <button
                type="button"
                onClick={() => openModal(<FormularioRD />)}
                className="bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] text-white font-poppins-light flex items-center gap-2 rounded-full py-2 px-6 md:px-4 text-sm w-fit h-fit cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              >
                Contratar
                <ArrowUpRight />
              </button>
            </div>
          </div>
          <div className="lg:w-2/3 md:px-16 lg:ml-auto">
            {accordionItems.map((item, index) => (
              // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
              <div
                key={index}
                className="border-t border-[#A800E4] py-6"
                onClick={() => setActiveItem(activeItem === index ? null : index)}
              >
                <div className="flex items-center justify-between cursor-pointer">
                  <div className="flex items-center gap-4">
                    <span className="text-white text-inter-regular text-xl">
                      {item.id}
                    </span>
                    <h3
                      className={cn(
                        'text-white font-inter-light text-base md:text-xl tracking-wider uppercase',
                        activeItem === index && 'font-inter-bold',
                      )}
                    >
                      {item.title}
                    </h3>
                  </div>
                  <button
                    type="button"
                    className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                      activeItem === index ? 'bg-[#A800E4]' : ''
                    }`}
                  >
                    {activeItem === index ? (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7 0L13.9282 7.5H0.0717969L7 0Z" fill="white" />
                      </svg>
                    ) : (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-180"
                      >
                        <path d="M7 0L13.9282 7.5H0.0717969L7 0Z" fill="white" />
                      </svg>
                    )}
                  </button>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    activeItem === index
                      ? 'max-h-[200px] opacity-100'
                      : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="text-[13px] md:text-base mt-4 pl-9 text-white pr-8 font-inter-regular">
                    {item.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </Container>
    </section>
  )
}
